import {
  toolCategoriesQuery,
  useDeleteToolCategoryMutation,
} from "@common/api/tool-categories"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete",
)({
  component: DeleteCategoryDialog,
})

function DeleteCategoryDialog(): React.ReactElement | null {
  const { categoryId } = Route.useParams()
  const { data } = useSuspenseQuery(toolCategoriesQuery())
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const deleteMutation = useDeleteToolCategoryMutation()
  const category = data.data.find((item) => item.id === categoryId)

  if (!category) {
    return null
  }

  const close = () =>
    navigate({
      to: "/settings/workspace/tool-categories/$categoryId",
      params: { categoryId },
      search: true,
    })

  const confirm = () =>
    deleteMutation.mutate(
      { category_id: categoryId },
      {
        onSuccess: () => {
          showToast("Archived", `${category.name} archived.`, "success")
          navigate({ to: "/settings/workspace/tool-categories", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${category.name}?`}
      description="Tools must be moved to another category first."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={deleteMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
